import React from 'react';
import PropTypes from 'prop-types';
import ResultCardLogo from './ResultCardLogo';
import ResultCardTitle from './ResultCardTitle';
import SchoolDates from './SchoolDates';

function ResultCardHeader({
  badge,
  isLoading,
  isMobile,
  logoImg,
  name,
  onLogoClick,
  onTitleClick,
  cardLink,
  impressionGuid,
  isProgramView,
  schoolDates,
}) {
  return (
    <>
      {badge && <span className="resultCard__badge">{badge}</span>}
      {isMobile && (
        <>
          <div className="resultCard__schoolLogo">
            <ResultCardLogo
              isLoading={isLoading}
              linkUrl={cardLink}
              logoImg={logoImg}
              onClick={onLogoClick}
              impressionGuid={impressionGuid}
              isProgramView={isProgramView}
            />
          </div>
          <ResultCardTitle
            className="resultCard__title"
            impressionGuid={impressionGuid}
            isProgramView={isProgramView}
            linkUrl={cardLink}
            onClick={onTitleClick}
          >
            {name}
          </ResultCardTitle>
          <SchoolDates
            className="resultCard__startDate"
            schoolDates={schoolDates}
          />
        </>
      )}
    </>
  );
}

ResultCardHeader.propTypes = {
  badge: PropTypes.string,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  logoImg: PropTypes.string,
  name: PropTypes.string,
  onLogoClick: PropTypes.func,
  onTitleClick: PropTypes.func,
  cardLink: PropTypes.string,
  impressionGuid: PropTypes.string,
  isProgramView: PropTypes.bool,
  schoolDates: PropTypes.array,
};

export default ResultCardHeader;
